
import { KngStatusSelectorState } from './definitions';

export class KngStatusSelectorFactory 
{
	public static build(): KngStatusSelectorState 
	{
		return {
			header: '',
			selectedStatus: 'all',
			count: [
				{
					header: '',
					label: '',
					amount: 0
				}
			]
		};
	}
}
